"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityActionToJSON = exports.ActivityActionFromJSONTyped = exports.ActivityActionFromJSON = exports.ActivityAction = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var ActivityAction;
(function (ActivityAction) {
    ActivityAction["Create"] = "create";
    ActivityAction["Update"] = "update";
    ActivityAction["Overwrite"] = "overwrite";
    ActivityAction["Delete"] = "delete";
    ActivityAction["Read"] = "read";
    ActivityAction["Relate"] = "relate";
    ActivityAction["Unrelate"] = "unrelate";
    ActivityAction["Archive"] = "archive";
    ActivityAction["Unarchive"] = "unarchive";
    ActivityAction["Cancel"] = "cancel";
    ActivityAction["ReverseCancel"] = "reverse_cancel";
    ActivityAction["Reschedule"] = "reschedule";
    ActivityAction["Complete"] = "complete";
    ActivityAction["OutcomeUpdated"] = "outcome_updated";
    ActivityAction["Inactivate"] = "inactivate";
    ActivityAction["Reactivate"] = "reactivate";
    ActivityAction["Assign"] = "assign";
    ActivityAction["Unassign"] = "unassign";
    ActivityAction["Pause"] = "pause";
    ActivityAction["Resume"] = "resume";
    ActivityAction["Approve"] = "approve";
    ActivityAction["Unapprove"] = "unapprove";
    ActivityAction["Intent"] = "intent";
    ActivityAction["SyncFailed"] = "sync-failed";
    ActivityAction["ChargedPayment"] = "charged_payment";
    ActivityAction["EmailSent"] = "email_sent";
    ActivityAction["SmsSent"] = "sms_sent";
})(ActivityAction || (exports.ActivityAction = ActivityAction = {}));
function ActivityActionFromJSON(json) {
    return ActivityActionFromJSONTyped(json, false);
}
exports.ActivityActionFromJSON = ActivityActionFromJSON;
function ActivityActionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ActivityActionFromJSONTyped = ActivityActionFromJSONTyped;
function ActivityActionToJSON(value) {
    return value;
}
exports.ActivityActionToJSON = ActivityActionToJSON;
//# sourceMappingURL=ActivityAction.js.map